import { render, staticRenderFns } from "./ScaleType.vue?vue&type=template&id=bab69b72&scoped=true"
import script from "./ScaleType.vue?vue&type=script&lang=js"
export * from "./ScaleType.vue?vue&type=script&lang=js"
import style0 from "./ScaleType.vue?vue&type=style&index=0&id=bab69b72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab69b72",
  null
  
)

export default component.exports